import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import RawHtml from 'common/RawHtml';
import { Collapse } from 'react-collapse';
import { withStyles } from '@glu/theming';
import { QuestionCircleNextIcon } from '@glu/icons-react';
import analyticsActions from 'core/analytics/actions';
import buttonLinkStyles from 'styles/buttonLink';

const styles = ({ links, palette, spacing, typography }) => ({
  handle: {
    '& svg': {
      fill: palette.icon,
      height: 16,
      width: 16,
    },
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    height: 16,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    right: 5,
    textIndent: -1000,
    top: 15,
    width: 16,
    zIndex: 10,
  },
  iconWrapper: {
    float: 'right',
  },
  link: {
    ...buttonLinkStyles({ links }),
    textDecoration: 'none',
  },
  panel: {
    ...typography.p3,
    '& p': {
      ...typography.p3,
    },
    display: 'block',
    marginTop: spacing.unit * 2,
  },
});

const Tooltip = ({ analyticsTooltipView, className, classes, labeledBy, tooltip }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const clientId = labeledBy.split('-')[labeledBy.split('-').length - 1] || '';
      analyticsTooltipView(clientId);
    }
  }, [analyticsTooltipView, isOpen, labeledBy]);

  if (!tooltip) {
    return null;
  }
  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen((o) => !o)}
        aria-controls={`${labeledBy}-tooltip-panel`}
        className={classnames('tooltip-handle', classes.handle)}
        aria-expanded={isOpen}
        title={`${isOpen ? 'Collapse' : 'Expand'} additional information`}
      >
        <QuestionCircleNextIcon classes={{ iconWrapper: classes.iconWrapper }} focusable={false} />
      </button>
      <Collapse isOpened={isOpen}>
        <div
          role="tabpanel"
          aria-labelledby={labeledBy}
          id={`${labeledBy}-tooltip-panel`}
          className={classnames(className, classes.panel)}
        >
          <RawHtml type="p">{tooltip}</RawHtml>{' '}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <button
            type="button"
            className={classnames('buttonLink', classes.link)}
            onClick={(e) => {
              e.preventDefault();
              setIsOpen((o) => !o);
            }}
            tabIndex={isOpen ? 0 : -1}
          >
            Close
          </button>
        </div>
      </Collapse>
    </>
  );
};

Tooltip.propTypes = {
  analyticsTooltipView: PropTypes.func.isRequired,
  className: PropTypes.string,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  labeledBy: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
};

Tooltip.defaultProps = {
  className: 'tooltip-text',
  tooltip: '',
};

const TooltipStyled = withStyles(styles)(Tooltip);
const mapStateToProps = () => ({});
export default connect(mapStateToProps, {
  analyticsTooltipView: analyticsActions.oaoTooltipView,
})(TooltipStyled);
